const HIGH_RESOLUTION = 'high';
const LOW_RESOLUTION = 'low';

const BITRATE_MAP = {
  [HIGH_RESOLUTION]: 2000,
  [LOW_RESOLUTION]: 1000,
};

const ON_ERROR = 'onError';
const ON_LOADING = 'onLoading';
const ON_META_DATA = 'onMetaData';
const ON_MUTE = 'onMute';
const ON_PAUSE = 'onPause';
const ON_PLAY = 'onPlay';
const ON_READY = 'onReady';
const ON_START_BUFFERING = 'onStartBuffering';
const ON_STATS = 'onStats';
const ON_STOP_BUFFERING = 'onStopBuffering';
const ON_STREAM_INFO = 'onStreamInfo';
const ON_STREAM_INFO_UPDATE = 'onStreamInfoUpdate';
const ON_UNMUTE = 'onUnmute';
const ON_VOLUME_CHANGE = 'onVolumeChange';
const ON_WARNING = 'onWarning';
const ON_SWITCH_STREAM_INIT = 'onSwitchStreamInit';
const ON_SWITCH_STREAM_SUCCESS = 'onSwitchStreamSuccess';
const ON_SWITCH_STREAM_FAIL = 'onSwitchStreamFail';
const ON_SWITCH_STREAM_ABORT = 'onSwitchStreamAbort';

export const VIDEO = {
  HIGH_RESOLUTION,
  LOW_RESOLUTION,
  BITRATE_MAP,
  ON_ERROR,
  ON_LOADING,
  ON_META_DATA,
  ON_MUTE,
  ON_PAUSE,
  ON_PLAY,
  ON_READY,
  ON_START_BUFFERING,
  ON_STATS,
  ON_STOP_BUFFERING,
  ON_STREAM_INFO,
  ON_STREAM_INFO_UPDATE,
  ON_UNMUTE,
  ON_VOLUME_CHANGE,
  ON_WARNING,
  ON_SWITCH_STREAM_INIT,
  ON_SWITCH_STREAM_SUCCESS,
  ON_SWITCH_STREAM_FAIL,
  ON_SWITCH_STREAM_ABORT,
};

export const SECURE_SOURCE_OPTIONS = {
  adaption: {
    rule: 'deviationOfMean',
  },
  switch: {
    method: 'server',
    pauseOnError: false,
    forcePlay: true,
    fastStart: false,
    timeout: 10,
  },
};
